import React, { Component } from 'react';
import _ from 'lodash';

import WorkflowProcessStore from '../../stores/WorkflowProcessStore';
import CommentStore from '../../stores/CommentStore';
import AfterSaveLoading from '../AfterSaveLoading';

class CommentForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      content: '',
      files: []
    }

    this.onChange = this.onChange.bind(this);
    this.handleChangeFile = this.handleChangeFile.bind(this);
    this.renderFile = this.renderFile.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onChange(event){
    const name = event.target.name;
    const value = event.target.value;

    this.setState({
      [name]: value
    })
  }

  handleChangeFile(){
    var file = this.refs.file.files[0];
    if (file.size === 0) { return }

    let { files } = this.state;
    let new_file = {file: file, file_name: file.name}
    files = _.concat(files, new_file);

    this.setState({
      files: files
    });
  }

  handleDeleteFile(index){
    let { files } = this.state;
    _.pullAt(files, [index]);

    this.setState({
      files: files
    });
  }

  renderFile(file, index){
    return (
      <div className='col-12 mb-2' key={`file_${index}`}>
        <div className='row'>
          <div className='col-12'>
            {file.file_name}
            <i className="fa fa-trash-o pointer text-danger ml-3" aria-hidden="true" onClick={this.handleDeleteFile.bind(this, index)}></i>
          </div>
        </div>
      </div>
    )
  }

  handleSubmit(){
    this.setState({loading: true});
    const { content, files } = this.state;
    const { workflow_process_id } = this.props;

    let data = new FormData();

    data.append('comment[content]', content);
    data.append('comment[workflow_process_id]', workflow_process_id);

    if (!_.isEmpty(files)){
      _.forEach(files, function(file){
        if (!_.isEmpty(file['file_name'])){
          data.append('comment_files[][file]', file['file']);
        }
      })
    }

    CommentStore.save(null, data).then((resp)=>{
      this.setState({content: '', files: [], loading: false}, this.props.onReloadWorkflowProcess(workflow_process_id));
    }, function(error){
      var error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message)
    })
  }

  render(){
    const { content, files } = this.state;
    return (
      <div className='row mb-3'>

        {this.state.loading && <AfterSaveLoading />}

        <div className='col-12'>
          <div className='row'>
            <div className='col-12'>ความคิดเห็น</div>
            <div className='col-12'>
              <textarea 
                name='content' 
                className="w-100 p-2" 
                rows="3"
                value={content}
                onChange={this.onChange}>
              </textarea>
            </div>
          </div>
        </div>

        {!_.isEmpty(files) && _.map(files, this.renderFile)}

        <div className='col-12 mb-3'>
          <div className='row'>
          <div className='col-12'>แนบไฟล์</div>
            <div className='col-12'>
              <input 
                type="file"
                ref="file"
                value=''
                onChange={this.handleChangeFile} />
            </div>
          </div>
        </div>

        <div className='col-12'>
          <div className="modal-footer row">
            <button type='button' className='btn btn-primary' onClick={this.handleSubmit}>บันทึก</button>
            <button type='button' className="btn btn-secondary pointer" onClick={this.props.onCloseModal}>ปิด</button>
          </div>
          
        </div>

      </div>
    )
  }
}

export default CommentForm;


// WEBPACK FOOTER //
// ./src/components/WorkflowActions/CommentForm.js